import { render } from "./ThankYou.vue?vue&type=template&id=366a7eed"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=366a7eed&lang=css"
script.render = render

export default script